import { clsx } from 'clsx'
import { Transition } from '@headlessui/react'
import { useTranslation } from 'react-i18next'

export type TextAreaProps = {
  value: string
  setValue: (value: string) => void
  label: string
  error?: string
}

export const TextArea = ({ value, setValue, label, error }: TextAreaProps) => {
  const { t } = useTranslation()
  return (
    <div className={'tw-flex tw-flex-col tw-text-sm'}>
      <div className={'tw-text-white tw-mb-1'}>{label}</div>
      <textarea
        placeholder={label}
        className={clsx('tw-rounded-md tw-h-30 tw-bg-slate-300/40 tw-p-2 tw-border-[1px] focus:tw-outline-none', {
          'tw-border-red-500 tw-text-red-500': !!error,
          'tw-border-slate-300': !error,
        })}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        style={{
          resize: 'none',
        }}
      />
      <Transition
        show={!!error}
        enter="tw-transition-opacity tw-duration-300"
        enterFrom="tw-opacity-0"
        enterTo="tw-opacity-100"
        leave="tw-transition-opacity tw-duration-300"
        leaveFrom="tw-opacity-100"
        leaveTo="tw-opacity-0"
        className={'tw-text-red-500 tw-text-xs'}
      >
        {t(error)}
      </Transition>
    </div>
  )
}
